import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { ProductAuditPageModel } from "../pageModels/ProductAuditPageModel";
import { ProductAudit } from "../../models/ProductAudit";
import EasyInput from "../../components/EasyInput/EasyInput";
import Loading from "../../components/Loading/Loading";
import { globalStore } from "../../models/globalStore";

const pageModel = new ProductAuditPageModel();

const ProductAuditPage: React.FC = observer(() => {
    const [activeTab, setActiveTab] = useState<"pending" | "processed">("pending");

    useEffect(() => {
        globalStore.selectedMenuKey = "product-audit";
        pageModel.loadCandidates();
        pageModel.loadProcessed();
    }, []);

    const renderAuditList = (audits: ProductAudit[]) => {
        return (
            <div style={{ padding: "20px" }}>
                {audits.map(audit => (
                    <div
                        key={audit.draftId}
                        style={{
                            padding: "15px",
                            border: "1px solid #eee",
                            marginBottom: "10px",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between"
                        }}
                        onClick={() => pageModel.setSelectedAudit(audit)}
                    >
                        <div style={{ fontSize: "16px", fontWeight: 200 }}>
                            {audit.productName}
                        </div>
                        <div style={{ color: "#666", fontSize: "14px", fontWeight: 200 }}>
                            卖家：{audit.sellerNickname} &nbsp;&nbsp; 头图：{audit.headImages?.length ?? 0}张 &nbsp;&nbsp; 
                            详情图：{audit.detailImages?.length ?? 0}张
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    const renderMobilePreview = () => {
        if (!pageModel.selectedAudit) return null;
        const audit = pageModel.selectedAudit;

        return (
            <div style={{ 
                width: "320px", 
                height: "100%", 
                borderRight: "1px solid #eee", 
                overflow: "auto",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start",
                padding: "15px"
            }}>
                {/* 苹果手机外壳 */}
                <div style={{
                    width: "280px",
                    height: "calc(100% - 30px)",
                    background: "#1a1a1a",
                    borderRadius: "35px",
                    padding: "6px",
                    boxShadow: "0 0 20px rgba(0,0,0,0.3)",
                    flexShrink: 0
                }}>
                    {/* 屏幕 */}
                    <div style={{
                        width: "100%",
                        height: "100%",
                        background: "white",
                        borderRadius: "29px",
                        overflow: "hidden",
                        position: "relative"
                    }}>
                        {/* 状态栏 */}
                        <div style={{
                            height: "38px",
                            background: "#000",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "0 18px",
                            color: "white",
                            fontSize: "12px",
                            fontWeight: 600,
                            position: "sticky",
                            top: 0,
                            zIndex: 10
                        }}>
                            <span>9:41</span>
                            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                <div style={{ width: "14px", height: "5px", background: "#fff", borderRadius: "2.5px" }}></div>
                                <div style={{ width: "14px", height: "5px", background: "#fff", borderRadius: "2.5px" }}></div>
                                <div style={{ width: "14px", height: "5px", background: "#fff", borderRadius: "2.5px" }}></div>
                            </div>
                        </div>

                        {/* 可滚动的内容区域 */}
                        <div style={{ 
                            height: "calc(100% - 38px)", 
                            overflow: "auto",
                            WebkitOverflowScrolling: "touch"
                        }}>
                            {/* 头图轮播 */}
                            <div style={{ position: "relative", width: "100%", height: "200px" }}>
                                {audit.headImages && audit.headImages.length > 0 && (
                                    <img
                                        src={audit.headImages[pageModel.currentImageIndex]}
                                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                        alt="商品图片"
                                    />
                                )}
                                {audit.headImages && audit.headImages.length > 1 && (
                                    <>
                                        <button
                                            style={{
                                                position: "absolute",
                                                left: "8px",
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                background: "rgba(0,0,0,0.5)",
                                                color: "white",
                                                border: "none",
                                                width: "28px",
                                                height: "28px",
                                                cursor: "pointer",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                fontSize: "14px"
                                            }}
                                            onClick={(e) => { e.stopPropagation(); pageModel.previousImage(); }}
                                        >
                                            ‹
                                        </button>
                                        <button
                                            style={{
                                                position: "absolute",
                                                right: "8px",
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                background: "rgba(0,0,0,0.5)",
                                                color: "white",
                                                border: "none",
                                                width: "28px",
                                                height: "28px",
                                                cursor: "pointer",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                fontSize: "14px"
                                            }}
                                            onClick={(e) => { e.stopPropagation(); pageModel.nextImage(); }}
                                        >
                                            ›
                                        </button>
                                    </>
                                )}
                            </div>

                            {/* 商品信息 */}
                            <div style={{ padding: "16px" }}>
                                {/* 商品标题 */}
                                <h2 style={{ 
                                    margin: "0 0 12px 0", 
                                    fontSize: "16px", 
                                    fontWeight: 600,
                                    lineHeight: "1.3",
                                    color: "#333"
                                }}>
                                    {audit.productName}
                                </h2>
                                
                                {/* 价格信息 */}
                                <div style={{ 
                                    background: "#f8f9fa", 
                                    padding: "12px", 
                                    marginBottom: "16px",
                                    borderRadius: "6px"
                                }}>
                                    <div style={{ marginBottom: "10px" }}>
                                        <div style={{ 
                                            fontWeight: 600, 
                                            marginBottom: "4px",
                                            color: "#333",
                                            fontSize: "13px"
                                        }}>标准版</div>
                                        <div style={{ 
                                            fontSize: "12px", 
                                            color: "#666",
                                            lineHeight: "1.4"
                                        }}>{audit.standardDescription}</div>
                                        <div style={{ 
                                            color: "#ff6b35", 
                                            marginTop: "6px",
                                            fontSize: "16px",
                                            fontWeight: 600
                                        }}>¥{audit.standardPrice}</div>
                                    </div>
                                    
                                    {audit.trialEnabled && (
                                        <div style={{ 
                                            borderTop: "1px solid #eee",
                                            paddingTop: "10px"
                                        }}>
                                            <div style={{ 
                                                fontWeight: 600, 
                                                marginBottom: "4px",
                                                color: "#333",
                                                fontSize: "13px"
                                            }}>体验版</div>
                                            <div style={{ 
                                                fontSize: "12px", 
                                                color: "#666",
                                                lineHeight: "1.4"
                                            }}>{audit.trialDescription}</div>
                                            <div style={{ 
                                                color: "#ff6b35", 
                                                marginTop: "6px",
                                                fontSize: "14px",
                                                fontWeight: 600
                                            }}>¥{audit.trialPrice}</div>
                                        </div>
                                    )}
                                </div>

                                {/* 详情图片 */}
                                <div style={{ marginTop: "16px" }}>
                                    {audit.detailImages && audit.detailImages.map((img, index) => (
                                        <img
                                            key={index}
                                            src={img}
                                            style={{ 
                                                width: "100%", 
                                                marginBottom: "10px",
                                                borderRadius: "6px"
                                            }}
                                            alt={`详情图${index + 1}`}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const renderAuditInfo = () => {
        if (!pageModel.selectedAudit) return null;
        const audit = pageModel.selectedAudit;

        return (
            <div style={{ flex: 1, padding: "16px", minWidth: "200px" }}>
                {/* 商品标题 */}
                <h2 style={{ 
                    margin: "0 0 20px 0", 
                    fontSize: "20px", 
                    fontWeight: 600,
                    lineHeight: "1.3",
                    color: "#333"
                }}>
                    {audit.productName}
                </h2>

                <div style={{ marginBottom: "20px" }}>
                    <div style={{ marginBottom: "10px" }}>
                        <span style={{ color: "#666" }}>卖家ID：</span>{audit.sellerId}
                    </div>
                    <div style={{ marginBottom: "10px" }}>
                        <span style={{ color: "#666" }}>卖家昵称：</span>{audit.sellerNickname}
                    </div>
                    <div style={{ marginBottom: "10px" }}>
                        <span style={{ color: "#666" }}>卖家等级：</span>{audit.sellerLevel}
                    </div>
                    <div style={{ marginBottom: "10px" }}>
                        <span style={{ color: "#666" }}>一级分类：</span>{audit.firstCategoryName}
                    </div>
                    <div style={{ marginBottom: "10px" }}>
                        <span style={{ color: "#666" }}>二级分类：</span>{audit.secondCategoryName}
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div style={{ height: "100vh", display: "flex", flexDirection: "column", fontWeight: 200 }}>
            <div style={{ padding: "30px 20px", paddingBottom: "0px" }}>
                <button
                    style={{
                        padding: "8px 16px",
                        marginRight: "10px",
                        border: "none",
                        background: activeTab === "pending" ? "#1890ff" : "#f5f5f5",
                        color: activeTab === "pending" ? "white" : "#666",
                        cursor: "pointer",
                        fontWeight: 400
                    }}
                    onClick={() => setActiveTab("pending")}
                >
                    待审核
                </button>
                <button
                    style={{
                        padding: "8px 16px",
                        border: "none",
                        background: activeTab === "processed" ? "#1890ff" : "#f5f5f5",
                        color: activeTab === "processed" ? "white" : "#666",
                        cursor: "pointer",
                        fontWeight: 400
                    }}
                    onClick={() => setActiveTab("processed")}
                >
                    已审核
                </button>
            </div>

            <div style={{ flex: 1, overflow: "auto" }}>
                {renderAuditList(activeTab === "pending" ? pageModel.candidates : pageModel.processed)}
            </div>

            {pageModel.selectedAudit && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: "rgba(0,0,0,0.5)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 1000
                }}>
                    <div style={{
                        background: "white",
                        width: "800px",
                        maxWidth: "1200px",
                        height: "90vh",
                        display: "flex"
                    }}>
                        {/* 左边手机预览区 */}
                        <div style={{ width: "320px", height: "100%" }}>
                            {renderMobilePreview()}
                        </div>
                        
                        {/* 右边内容区域 */}
                        <div style={{ 
                            flex: 1, 
                            display: "flex", 
                            flexDirection: "column",
                            borderLeft: "1px solid #eee"
                        }}>
                            {/* 标题行 */}
                            <div style={{
                                padding: "16px 24px",
                                borderBottom: "1px solid #eee",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center"
                            }}>
                                <h3 style={{ margin: 0, fontWeight: 400 }}>商品上架审核</h3>
                                <div>
                                    {(activeTab === "pending" || pageModel.canAuditSelected()) && (
                                        <>
                                            <button
                                                style={{
                                                    marginRight: "10px",
                                                    padding: "6px 12px",
                                                    background: "#52c41a",
                                                    color: "white",
                                                    border: "none",
                                                    cursor: "pointer",
                                                    fontWeight: 400
                                                }}
                                                onClick={() => pageModel.setShowConfirmDialog(true)}
                                            >
                                                审核通过
                                            </button>
                                            <button
                                                style={{
                                                    marginRight: "10px",
                                                    padding: "6px 12px",
                                                    background: "#ff4d4f",
                                                    color: "white",
                                                    border: "none",
                                                    cursor: "pointer",
                                                    fontWeight: 400
                                                }}
                                                onClick={() => pageModel.setShowRefuseDialog(true)}
                                            >
                                                拒绝通过
                                            </button>
                                        </>
                                    )}
                                    <button
                                        style={{
                                            padding: "6px 12px",
                                            background: "#f5f5f5",
                                            border: "none",
                                            cursor: "pointer",
                                            fontWeight: 400
                                        }}
                                        onClick={() => pageModel.setSelectedAudit(null)}
                                    >
                                        关闭
                                    </button>
                                </div>
                            </div>
                            
                            {/* 信息区域 */}
                            <div style={{ flex: 1, overflow: "auto" }}>
                                {renderAuditInfo()}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {pageModel.showConfirmDialog && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: "rgba(0,0,0,0.5)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 1100
                }}>
                    <div style={{
                        background: "white",
                        width: "400px",
                        padding: "24px",
                        fontWeight: 200
                    }}>
                        <h3 style={{ margin: "0 0 16px 0", fontWeight: 200 }}>确认审核通过</h3>
                        <p style={{ fontWeight: 200 }}>确认通过该商品的审核吗？</p>
                        <div style={{ marginTop: "24px", textAlign: "right" }}>
                            <button
                                style={{
                                    marginRight: "10px",
                                    padding: "6px 12px",
                                    background: "#f5f5f5",
                                    border: "none",
                                    cursor: "pointer",
                                    fontWeight: 200
                                }}
                                onClick={() => pageModel.setShowConfirmDialog(false)}
                            >
                                取消
                            </button>
                            <button
                                style={{
                                    padding: "6px 12px",
                                    background: "#52c41a",
                                    color: "white",
                                    border: "none",
                                    cursor: "pointer",
                                    fontWeight: 200
                                }}
                                onClick={() => pageModel.approveAudit()}
                            >
                                确认
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {pageModel.showRefuseDialog && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: "rgba(0,0,0,0.5)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 1100
                }}>
                    <div style={{
                        background: "white",
                        width: "400px",
                        padding: "24px",
                        fontWeight: 200
                    }}>
                        <h3 style={{ margin: "0 0 16px 0", fontWeight: 200 }}>拒绝通过</h3>
                        <EasyInput
                            label="拒绝原因"
                            type={0}
                            value={pageModel.refuseReason}
                            onChange={(value: string) => pageModel.setRefuseReason(value)}
                            height="100px"
                        />
                        <div style={{ textAlign: "right" }}>
                            <button
                                style={{
                                    marginRight: "10px",
                                    padding: "6px 12px",
                                    background: "#f5f5f5",
                                    border: "none",
                                    cursor: "pointer",
                                    fontWeight: 200
                                }}
                                onClick={() => pageModel.setShowRefuseDialog(false)}
                            >
                                取消
                            </button>
                            <button
                                style={{
                                    padding: "6px 12px",
                                    background: "#ff4d4f",
                                    color: "white",
                                    border: "none",
                                    cursor: "pointer",
                                    fontWeight: 200
                                }}
                                onClick={() => pageModel.refuseAudit()}
                                disabled={!pageModel.refuseReason}
                            >
                                确认
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {pageModel.loading && <Loading />}
        </div>
    );
});

export default ProductAuditPage; 